import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PlanComponent } from './plan.component';

import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { locationHostFactory } from '../../../core/services/window/locationFactory';

@NgModule({
  imports: [CommonModule, PipesModule],
  providers: [{ provide: 'HOSTNAME', useFactory: locationHostFactory }],
  exports: [PlanComponent],
  declarations: [PlanComponent],
})
export class PlanModule {}
